/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 抵扣转欠货 的 **请求配置**
 *
 * @分类 采购API/代采商品
 * @请求头 `POST /erp/Deduction/dedTransferOut`
 */
const postDedTransferOutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Deduction/dedTransferOut",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDedTransferOut",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 抵扣转欠货 的 **请求函数**
 *
 * @分类 采购API/代采商品
 * @请求头 `POST /erp/Deduction/dedTransferOut`
 */
export const postDedTransferOut = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postDedTransferOutRequestConfig, requestData),
    ...args
  );
};
postDedTransferOut.requestConfig = postDedTransferOutRequestConfig;
/**
 * 接口 抵扣列表 的 **请求配置**
 *
 * @分类 采购API/代采商品
 * @请求头 `POST /erp/Deduction/goodsDedList`
 */
const postGoodsDedListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Deduction/goodsDedList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGoodsDedList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 抵扣列表 的 **请求函数**
 *
 * @分类 采购API/代采商品
 * @请求头 `POST /erp/Deduction/goodsDedList`
 */
export const postGoodsDedList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGoodsDedListRequestConfig, requestData), ...args);
};
postGoodsDedList.requestConfig = postGoodsDedListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/deduction.js